import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ArrowLeft, Loader2, Mail } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSuccess(true);
    } catch (error) {
      setError(error.response?.data?.detail || 'Error al procesar solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Image */}
      <div
        className="hidden lg:block lg:w-1/2 relative bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/30887567/pexels-photo-30887567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)',
        }}
      >
        <div className="absolute inset-0 bg-[#2B4C3B]/10 backdrop-blur-sm"></div>
      </div>

      {/* Right side - Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-[#FDFBF7]">
        <div className="w-full max-w-md space-y-8">
          {!success ? (
            <>
              <div className="text-center">
                <h1 className="text-4xl font-bold text-[#2B4C3B] tracking-tight">Recuperar Contraseña</h1>
                <p className="mt-2 text-[#6A736B]">Ingresa tu email para recibir instrucciones</p>
              </div>

              <form onSubmit={handleSubmit} className="mt-8 space-y-6" data-testid="forgot-password-form">
                <div>
                  <Label htmlFor="email" className="text-[#1A1C18]">Email</Label>
                  <Input
                    id="email"
                    data-testid="forgot-email-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="mt-1 bg-transparent border-[#E8E5DD] focus:ring-2 focus:ring-[#2B4C3B] focus:border-transparent"
                    placeholder="tu@email.com"
                  />
                </div>

                {error && (
                  <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-800">{error}</p>
                  </div>
                )}

                <Button
                  type="submit"
                  data-testid="submit-forgot-password"
                  disabled={loading}
                  className="w-full bg-[#2B4C3B] hover:bg-[#3A604D] text-white rounded-lg h-11 transition-colors duration-200"
                >
                  {loading ? (
                    <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      Enviando...
                    </>
                  ) : (
                    <>
                      <Mail className="mr-2 h-4 w-4" />
                      Enviar Instrucciones
                    </>
                  )}
                </Button>

                <div className="text-center">
                  <Link
                    to="/login"
                    className="inline-flex items-center gap-2 text-[#2B4C3B] hover:text-[#3A604D] font-medium transition-colors"
                  >
                    <ArrowLeft size={16} />
                    Volver al login
                  </Link>
                </div>
              </form>
            </>
          ) : (
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-[#EDF5F0] rounded-full flex items-center justify-center mx-auto">
                <Mail className="text-[#4A7C59]" size={32} />
              </div>
              <h2 className="text-2xl font-bold text-[#2B4C3B]">Revisa tu email</h2>
              <p className="text-[#6A736B]">
                Si el email existe en nuestro sistema, recibirás instrucciones para restablecer tu contraseña.
              </p>
              <p className="text-sm text-[#6A736B]">
                <strong>Nota:</strong> En desarrollo, revisa la consola del servidor para ver el link de reseteo.
              </p>
              <Link to="/login">
                <Button className="mt-4 bg-[#2B4C3B] hover:bg-[#3A604D] text-white">
                  Volver al login
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}